export const TOP = 'TOP'
export const BOTTOM = 'BOTTOM'
export const RIGHT = 'RIGHT'
export const LEFT = 'LEFT'

export default {
	TOP, BOTTOM, RIGHT, LEFT
}
